import { render, staticRenderFns } from "./ProjectReprintArchive.vue?vue&type=template&id=be6b3300&scoped=true&lang=pug&"
import script from "./ProjectReprintArchive.vue?vue&type=script&lang=ts&"
export * from "./ProjectReprintArchive.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectReprintArchive.vue?vue&type=style&index=0&id=be6b3300&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6b3300",
  null
  
)

export default component.exports